import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ showLabel = true, variant = 'dropdown' }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: '(English)', flag: 'ENG' },
    { code: 'fr', name: '(Français)', flag: 'FRA' },
    { code: 'sw', name: '(Swahili)', flag: 'SWA' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    localStorage.setItem('dashbasket_language', languageCode); // Persist language selection
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  if (variant === 'buttons') {
    return (
      <div className="language-switcher language-switcher--buttons">
        {showLabel && (
          <span className="language-switcher__label">Select Language:</span>
        )}
        <div className="language-switcher__buttons">
          {languages.map((language) => (
            <button
              key={language.code}
              className={`language-switcher__button ${
                i18n.language === language.code ? 'language-switcher__button--active' : ''
              }`}
              onClick={() => handleLanguageChange(language.code)}
              title={language.name}
            >
              <span className="language-switcher__flag">{language.flag}</span>
              <span className="language-switcher__name">{language.name}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="language-switcher language-switcher--dropdown">
      {showLabel && (
        <span className="language-switcher__label">Select Language:</span>
      )}
      <div className="language-switcher__dropdown">
        <div 
          className="language-switcher__current"
          onClick={toggleDropdown}
        >
          <span className="language-switcher__flag">{currentLanguage.flag}</span>
          {/* <span className="language-switcher__name">{currentLanguage.name}</span> */}
          <span className={`language-switcher__arrow ${isOpen ? 'open' : ''}`}>▼</span>
        </div>
        
        {isOpen && (
          <div className="language-switcher__options">
            {languages.map((language) => (
              <div
                key={language.code}
                className={`language-switcher__option ${
                  i18n.language === language.code ? 'active' : ''
                }`}
                onClick={() => handleLanguageChange(language.code)}
              >
                <span className="language-switcher__flag">{language.flag}</span>
                <span className="language-switcher__name">{language.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSwitcher; 